import { render, staticRenderFns } from "./TaskCreateGroup.vue?vue&type=template&id=18cb69f8"
import script from "./TaskCreateGroup.vue?vue&type=script&lang=ts"
export * from "./TaskCreateGroup.vue?vue&type=script&lang=ts"
import style0 from "./TaskCreateGroup.vue?vue&type=style&index=0&id=18cb69f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports